'use strict';

var Utils = require('../../utils/utils');

var NavCollapse = function(config) {
  var self = this;
  var $toggle = $(config.navListGroupToggle);
  var $innerList = $(config.navInnerList);

  self.parseGroups = function() {
    $(config.navListGroup).each(function() {
      var $this = $(this);
      var _$toggle = $this.find($toggle);
      var _$innerList = $this.find($innerList);
      self.clickHandler(_$toggle, _$innerList);
    });
  }

  self.clickHandler = function(_$toggle, _$innerList) {
    _$toggle.on('click.chronologyNavCollapse', new Utils().throttle(function() {
      self.listVisibility(_$toggle, _$innerList);
    }, 300));
  }

  self.listVisibility = function(_$toggle, _$innerList) {
    if (!_$innerList.hasClass('velocity-animating') && !_$innerList.hasClass('is-visible')) {
      self.showList(_$toggle, _$innerList);
    }
  }

  self.showList = function(_$toggle, _$innerList) {

    if ($innerList.hasClass('is-visible')) {
      self.hideList($toggle, $innerList);
    }

    var $firstYear = _$innerList.find(config.navInnerLink).first()

    _$innerList
      .velocity('slideDown',{
        easing: 'easeOutQuart',
        duration: 300,
        complete: function() {
          _$innerList.addClass('is-visible');
          _$toggle
            .addClass('is-active')
            .attr('aria-expanded', 'false');
          $firstYear.trigger('click');
        }
      })
      .velocity({
        opacity: 1
      });
  }

  self.hideList = function(_$toggle, _$innerList) {
    _$innerList
      .velocity({
        opacity: 0
      })
      .velocity('slideUp',{
        easing: 'easeOutQuart',
        duration: 300,
        complete: function() {
          _$innerList.removeClass('is-visible');
          _$toggle
            .removeClass('is-active')
            .attr('aria-expanded', 'true');
        }
      });
  }

  self.init = function() {
    self.parseGroups();
  }
};

module.exports = NavCollapse;
